export const SideSunIcon = (): JSX.Element => (
  <svg
    width="163"
    height="185"
    viewBox="0 0 163 185"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.7899 12.0542C78.2931 15.3711 79.6774 17.9335 80.7222 19.8675C80.7464 19.9123 80.7704 19.9567 80.7942 20.0008C80.819 20.0468 80.8437 20.0926 80.868 20.1379C81.9882 22.2219 82.6389 23.639 82.1919 25.4937C81.7909 27.1574 80.4307 29.1575 78.9511 30.8929C78.2424 31.724 77.5613 32.4316 77.0575 32.9312C76.8063 33.1802 76.6012 33.3756 76.461 33.5066C76.391 33.5721 76.3374 33.6214 76.3026 33.6532L76.2648 33.6875L76.2571 33.6945L76.2567 33.6948L76.2564 33.695L76.2563 33.6952L76.2562 33.6952C76.2025 33.7432 76.152 33.7934 76.1047 33.8456C73.8196 33.0396 71.4945 32.3391 69.1375 31.745C70.7314 29.0592 70.5821 25.241 68.559 22.0731C67.161 19.8842 65.5681 19.0328 63.9534 18.4163C63.6287 18.2923 63.3175 18.181 63.0134 18.0721C61.875 17.6648 60.8349 17.2926 59.5517 16.4248C58.1748 15.4935 57.8245 14.5059 57.73 13.8408C57.6781 13.4758 57.6987 13.1588 57.7309 12.9405C57.7468 12.8328 57.7646 12.7547 57.7751 12.7136C57.7784 12.7006 57.7809 12.6916 57.7823 12.6869C58.1212 11.6512 57.5674 10.5314 56.5335 10.1748C55.4893 9.81455 54.3508 10.369 53.9906 11.4132L55.8813 12.0654C53.9906 11.4132 53.9902 11.4143 53.9898 11.4154L53.989 11.4177L53.9874 11.4227L53.9837 11.4335L53.9752 11.4594C53.969 11.4785 53.9619 11.5012 53.954 11.5274C53.9381 11.5798 53.9192 11.6465 53.8989 11.7262C53.8584 11.8853 53.8118 12.0988 53.7737 12.357C53.698 12.8704 53.653 13.5818 53.7698 14.4037C54.0127 16.1126 54.9374 18.133 57.3108 19.7382C59.053 20.9164 60.64 21.4787 61.8152 21.8952C62.0731 21.9865 62.3111 22.0709 62.5266 22.1531C63.6494 22.5819 64.4024 22.9964 65.1878 24.2261C66.9657 27.0099 66.1622 29.6202 64.999 30.49C64.8733 30.5839 64.7529 30.6694 64.6375 30.7472C41.8391 26.3715 16.5919 31.685 -4.2801 47.3915C-41.7744 75.6063 -50.9518 126.675 -24.7783 161.456C8.1054 205.155 53.008 201.561 90.5023 173.346C116.923 153.465 129.283 122.236 125.122 93.3535L138.573 88.6277C138.826 88.822 139.088 89.0287 139.362 89.2465L139.469 89.3317C141.286 90.7757 143.719 92.7095 147.304 92.4698C150.691 92.2433 154.14 90.1008 156.523 88.3124C157.764 87.3806 158.818 86.4648 159.562 85.7827C159.935 85.4408 160.233 85.1552 160.439 84.9527C160.509 84.8846 160.568 84.8258 160.617 84.7773L160.68 84.7139L160.719 84.6738L160.746 84.647L160.765 84.6277L160.77 84.6218L160.772 84.6198L160.773 84.619C160.773 84.6187 160.774 84.6184 159.367 83.259L160.774 84.6184C161.541 83.8242 161.52 82.558 160.726 81.7903C159.932 81.0228 158.666 81.0441 157.898 81.8378L143.065 87.0492C142.682 86.7705 142.281 86.4571 141.849 86.1142L141.678 85.9776C139.883 84.5495 137.478 82.6351 133.955 82.7771C130.309 82.924 126.624 85.1821 123.976 87.2029C121.704 77.3018 117.413 67.8028 111.001 59.2814C102.821 48.4118 92.1571 40.4192 80.2159 35.4281C80.7272 34.908 81.3488 34.2458 81.9948 33.4882C83.5293 31.6886 85.4429 29.0764 86.0805 26.431C86.9199 22.9485 85.4861 20.2809 84.3972 18.2551L84.3913 18.2441C83.237 16.0966 82.4519 14.6087 82.7458 12.6468C82.9375 11.3673 83.5709 9.68733 84.2313 8.21769C84.5506 7.50703 84.8568 6.88757 85.0828 6.44657C85.1956 6.22658 85.2877 6.05231 85.3507 5.93481C85.3821 5.87609 85.4062 5.83164 85.422 5.80284L85.4391 5.7716L85.4427 5.76513L85.4428 5.76495L85.4429 5.76462L85.443 5.76455L85.4431 5.7644L85.4431 5.76428C85.9788 4.79872 85.6307 3.58161 84.6652 3.04549C83.6995 2.50925 82.482 2.85737 81.9458 3.82304L83.6942 4.79399C81.9458 3.82304 81.9456 3.82324 81.9455 3.82347L81.9452 3.82399L81.9445 3.82535L81.9423 3.82929L81.9353 3.84196L81.9111 3.88606C81.8906 3.92362 81.8615 3.9773 81.8248 4.0457C81.7516 4.18242 81.6481 4.37834 81.5231 4.62213C81.2737 5.1087 80.9363 5.79123 80.5827 6.57827C79.8971 8.10403 79.0674 10.2023 78.7899 12.0542ZM143.065 87.0493L138.573 88.6277L138.572 88.6276L143.065 87.0492L143.065 87.0493ZM143.065 87.0493L157.898 81.8382L157.897 81.8388L157.887 81.8491L157.84 81.8973C157.796 81.9415 157.728 82.0088 157.639 82.0963C157.461 82.2713 157.196 82.5259 156.859 82.8344C156.184 83.4534 155.232 84.2799 154.121 85.1134C151.8 86.8558 149.167 88.3363 147.037 88.4787C145.54 88.5788 144.411 88.0279 143.065 87.0493ZM138.572 88.6276C137.014 87.4307 135.793 86.7063 134.116 86.7739C131.666 86.8726 128.681 88.5965 126.068 90.6412C125.64 90.9756 125.234 91.3097 124.854 91.6338C124.95 92.206 125.039 92.7793 125.122 93.3535L138.572 88.6276Z"
        fill="#FDDA05"
      />
      <g filter="url(#filter0_f)">
        <ellipse
          cx="24.9268"
          cy="89.2012"
          rx="8.5"
          ry="7.5"
          fill="#FB9378"
          fillOpacity="0.38"
        />
      </g>
      <g filter="url(#filter1_f)">
        <ellipse
          cx="91.2401"
          cy="81.2094"
          rx="8.5"
          ry="7.9633"
          transform="rotate(-21.3167 91.2401 81.2094)"
          fill="#FB9378"
          fillOpacity="0.38"
        />
      </g>
      <path
        d="M70.8308 81.6999C70.8308 81.6999 69.0713 86.8854 59.4694 87.6004C49.8675 88.3154 48.4263 83.3682 48.4263 83.3682"
        stroke="#999999"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="40.4268" cy="76.7012" r="2" fill="#666666" />
      <circle cx="76.4268" cy="74.7012" r="2" fill="#666666" />
    </g>
    <defs>
      <filter
        id="filter0_f"
        x="14.4268"
        y="79.7012"
        width="21"
        height="19"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="filter1_f"
        x="80.8066"
        y="71.1719"
        width="20.8667"
        height="20.0762"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <clipPath id="clip0">
        <rect
          width="232"
          height="222"
          fill="white"
          transform="translate(-69)"
        />
      </clipPath>
    </defs>
  </svg>
);
